import { render } from "./NoticiasList.vue?vue&type=template&id=a19fd37e"
import script from "./NoticiasList.vue?vue&type=script&lang=js"
export * from "./NoticiasList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__